import React from 'react';
import VirtualTerminalComponent from './virtual-terminal.component';

function VirtualTerminal(props) {
    return <VirtualTerminalComponent {...props} />;
}

export default VirtualTerminal;
